import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-report\"><defs><style type=\"text/css\"></style></defs><path d=\"M495.49312 176.37376C301.01504 176.37376 143.36 334.0288 143.36 528.50688S301.01504 880.64 495.49312 880.64s352.13312-157.65504 352.13312-352.13312H495.49312V176.37376z\" fill=\"#ffffff\" p-id=\"5684\" /><path d=\"M528.50688 143.36v352.13312H880.64C880.64 301.01504 722.98496 143.36 528.50688 143.36z\" fill=\"#ffffff\" p-id=\"5685\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/report.svg
// module id = Pmo1
// module chunks = 1